export default {
  missingMarkets: {
    id: 'listing_detail_shipping_methods_missing_markets',
    defaultMessage: 'Those markets have missing shipping methods:',
  },
  market: {
    id: 'listing_detail_shipping_methods_market',
    defaultMessage: 'Market',
  },
  shippingMethodsSection: {
    id: 'listing_detail_shipping_methods_section',
    defaultMessage: 'Shipping Section',
  },
  shippingLevel: {
    id: 'listing_detail_shipping_methods_shipping_level',
    defaultMessage: 'Shipping Level',
  },
  shippingProvider: {
    id: 'listing_detail_shipping_methods_shipping_provider',
    defaultMessage: 'Shipping Provider',
  },
  shippingDeadline: {
    id: 'listing_detail_shipping_methods_shipping_deadline',
    defaultMessage: 'Shipping Deadline',
  },
  shippingCost: {
    id: 'listing_detail_shipping_methods_shipping_cost',
    defaultMessage: 'Cost',
  },
  fetchingData: {
    id: 'listing_detail_shipping_methods_fetching_data',
    defaultMessage: 'We are fetching the data...',
  },
  delete: {
    id: 'listing_detail_shipping_methods_delete',
    defaultMessage: 'Delete',
  },
  toastErrorTitle: {
    id: 'listing_detail_toast_error_title',
    defaultMessage: 'Oops!',
  },
  toastErrorContent: {
    id: 'listing_detail_toast_error_generic_content',
    defaultMessage: 'We are sorry, something went wrong!',
  },
  toastSuccessTitle: {
    id: 'listing_detail_toast_success_title',
    defaultMessage: 'Well done!',
  },
  toastSuccessContent: {
    id: 'listing_detail_toast_succcess_content',
    defaultMessage: 'The shipping method is now deleted!',
  },
  infoText: {
    id: 'listing_detail_shipping_methods_info_text',
    defaultMessage:
      'You can add new shipping methods at the listing level or manage your shipping methods at the category level on the Options tab.',
  },
  manageShippingButton: {
    id: 'listing_detail_shipping_methods_manage_shipping_button',
    defaultMessage: 'Manage shipping in Options',
  },
  addShippingButton: {
    id: 'listing_detail_shipping_methods_add_shipping_button',
    defaultMessage: 'Add shipping to this listing',
  },
  methodDelay: {
    id: 'listing_detail_shipping_methods_method_delay',
    defaultMessage: '{delay} hours',
  },
  addShippingFormTitle: {
    id: 'listing_detail_shipping_methods_add_shipping_form_title',
    defaultMessage: 'Add a new shipping method for this listing',
  },
  addFormSection: {
    id: 'listing_detail_shipping_methods_form_label',
    defaultMessage: 'Add shipping method form',
  },
  addShippingFormDescription: {
    id: 'listing_detail_shipping_methods_form_description',
    defaultMessage:
      'When you enter a shipping method at the listing level, it will replace any existing shipping method for that listing in all markets.',
  },
  submitButtonText: {
    id: 'listing_detail_shipping_methods_form_submit_button_text',
    defaultMessage: 'Add this shipping method to this listing',
  },
  toastCreationSuccessTitle: {
    id: 'listing_detail_shipping_methods_form_toast_success_title',
    defaultMessage: 'Well done!',
  },
  toastCreationSuccessContent: {
    id: 'listing_detail_toast_succcess_content_add_shipping',
    defaultMessage: 'The shipping method is now created!',
  },
}
